import storeutilis from '@/helpers/storeutilis';

export default {
	socket: state => {
        return state.socket;
    },
    online: state => {
        return state.online;
    },
    offline: state => {
        return !state.online;
    },
    pool: state => {
        return state.pool;
    },


    live: state => {
    	return state.live;
    },
    getFromLive: (state, getters) => (name) => {
    	if(!getters['live']) return false;
    	if(!getters['live'][name]) return false;
    	return getters['live'][name];
    }
}




// WEBPACK FOOTER //
// ./src/store/socket/getters.js